import styled from "styled-components";

export const TableWrapper = styled.div`
	background-color: #22252d;

	.searchWrapper {
		padding: 1rem 1rem 0 1rem;
	}
`;
